export default function firstCharToLowerCase(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
}
